import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, retry, throwError, timer } from 'rxjs';

/**
 * Reintenta requests GET fallidos hasta 2 veces con backoff exponencial.
 * Solo reintenta errores de red (status 0) o errores de servidor (5xx).
 * NO reintenta errores del cliente (4xx): 401, 403, 404, 429, etc.
 */
@Injectable({ providedIn: 'root' })
export class RetryInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method !== 'GET') return next.handle(req);

    return next.handle(req).pipe(
      retry({
        count: 2,
        delay: (err: HttpErrorResponse, retryIndex: number) => {
          // No reintentar errores del cliente (4xx) — solo red (0) o servidor (5xx)
          if (err.status > 0 && err.status < 500) {
            return throwError(() => err);
          }
          return timer(300 * 2 ** retryIndex);
        },
      }),
    );
  }
}
